import React from "react";
import "../../styles/components/RelatioHero.css";

import futuraTablet from "../../img/cases/futura-tablet-2.webp";
import cloudsImage from "../../img/cases/case-clouds-2.webp";
import futuraLogo from "../../img/cases/futura-logo.png";

export default function FuturaHero() {
    return (
        <section className="relatio-hero relatio-hero--futura relatio-hero-anim">
            <div className="relatio-hero__content relatio-hero-anim__content">
                <h1 className="relatio-hero__title">
                    AI-Powered Competitive <strong>Analysis</strong>
                    <br />
                    <strong>Platform</strong> for Marketing Teams
                </h1>

                <p className="relatio-hero__text">
                    An agentic AI system that crawls competitor funnels, collects ad creatives, and delivers 
                    structured strategic insights — in minutes instead of days.
                </p>

                <div className="relatio-hero__chips">
                    <span>Docker</span>
                    <span>Playwright</span>
                    <span>LangChain</span>
                    <span>GPT family</span>
                    <span>Gemini family</span>
                </div>
            </div>

            <div className="relatio-hero__glass relatio-hero__glass--client relatio-hero-anim__glass-1">
                <span>Client</span>
                <img
                    className="relatio-hero__logo relatio-hero__logo--futura"
                    src={futuraLogo}
                    alt="Futura"
                />
            </div>

            <div className="relatio-hero__glass relatio-hero__glass--industry relatio-hero-anim__glass-2">
                <span>Industry</span>
                <strong>MARKETING</strong>
            </div>

            <img
                className="relatio-hero__clouds relatio-hero-anim__clouds"
                src={cloudsImage}
                alt=""
                aria-hidden="true"
            />

            <img
                className="relatio-hero__phone relatio-hero__phone--futura relatio-hero-anim__phone"
                src={futuraTablet}
                alt="Futura platform"
            />
        </section>
    );
}
